import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import CookieConsent from "react-cookie-consent";
import styled from 'styled-components';

const IgniteFooter = (props) => {
  const StyledDiv = styled.div`
  &:hover {
    color: ${props.menuTextHoverColor ? props.menuTextHoverColor : "inherited"};
    // Add other hover styles as needed
  }
`;

  return (
    <Navbar fixed="bottom" style={{ backgroundColor: props.menuBgColor ? props.menuBgColor : "#414141"}}>
      <Container>
      <CookieConsent style={{ zIndex: "999" }}>This website uses cookies to enhance the user experience.</CookieConsent>
      <Nav>
            <Nav.Link style={{color: props.menuTextColor ? props.menuTextColor : "#FFFFFF", fontSize: 16}} href="/privacypolicy"><StyledDiv>Privacy Policy</StyledDiv></Nav.Link>
            <Nav.Link style={{color: props.menuTextColor ? props.menuTextColor : "#FFFFFF", fontSize: 16}} href="/about"><StyledDiv>About Ignite</StyledDiv></Nav.Link>
            <Nav.Link style={{color: props.menuTextColor ? props.menuTextColor : "#FFFFFF", fontSize: 16}} href="/contact"><StyledDiv>Contact Us</StyledDiv></Nav.Link>
            <Nav.Link style={{color: props.menuTextColor ? props.menuTextColor : "#FFFFFF", fontSize: 16}} href="#"><StyledDiv>&copy; {new Date().getFullYear()} Ignite Business Solutions, LLC</StyledDiv></Nav.Link>
          </Nav>
      </Container>
    </Navbar>

  );
};
export default IgniteFooter;



